import React, { Component } from 'react'; 
 
class CertificatesContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      page_content: [],
      loading: 1,
      settings: {},
      showModal: false, // 👈 for popup
      selectedImage: null, // 👈 to store clicked image
    };
  }

  componentDidMount() {
    this.setState({ loading: 0 });
  }

  // 👇 Open popup
  handleImageClick = (image) => {
    this.setState({ showModal: true, selectedImage: image });
  };

  // 👇 Close popup
  closeModal = () => {
    this.setState({ showModal: false, selectedImage: null });
  };

  render() {
    if (this.state.loading === 1) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <div className="section-full p-t80 p-b0 bg-white">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="row masonary">
                  {this.props.certificates.map((item, index) => (
                    <div
                      key={index}
                      className="col-3 pf-item construction"
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleImageClick(item.image)} // 👈 click handler
                    >
                      <div className="item">
                        <div className="effect-up">
                          <img
                            src={item.image}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>
                        <div className="info">
                          <h3>{item.title}</h3>
                          <ul>
                            <li>{item.subtitle}</li>
                          </ul>
                          <br />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 👇 Popup modal */}
        {this.state.showModal && (
          <div className="modal-overlay" onClick={this.closeModal}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()} // prevent close on content click
            >
              <span className="close-btn" onClick={this.closeModal}>
                &times;
              </span>
              <img
                src={this.state.selectedImage}
                alt="Certificate"
                className="modal-image"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CertificatesContent;
